var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfCircleRotated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 136,
    viewBox: "0 0 69 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2338 13.8419L68.2945 0.30332C30.9076 0.135786 0.469682 30.3021 0.302175 67.6831C0.134641 105.07 30.3009 135.516 67.6878 135.683L67.7485 122.145C37.8387 122.011 13.7067 97.6556 13.8408 67.7457C13.9747 37.8458 38.3236 13.7079 68.2338 13.8419Z",
    fill: "#F6F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircleRotated);
export default __webpack_public_path__ + "static/media/halfCircleRotated.863e7b206e208b78701c09594009fff0.svg";
export { ForwardRef as ReactComponent };